import { CommonService } from 'src/app/shared/utils/common.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { PageName } from 'src/app/shared/utils/user-roles';

import {
  IUserGroup,
  IUserGroups,
} from '../../add-user/add-user-management.interface';
import {
  IGroupUser,
  IUserGroupDetails,
} from '../../user-management-interfaces';
import { Subject, Subscription } from 'rxjs';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { UserManagementService } from '../../user-management.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { UserCards } from 'src/app/shared-layout/Components/activity/user-card.interface';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from 'src/app/shared/state-management/state-interfaces';
import { addFlagIfMatched } from 'src/app/shared/utils/utility.service';

@Component({
  selector: 'app-user-group-listing',
  templateUrl: './user-group-listing.component.html',
  styleUrls: ['./user-group-listing.component.scss'],
})
export class UserGroupListingComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() formGroupDeviceName!: string;
  @Input() formGroupUserDetailName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() userGroupList!: IUserGroupDetails[];
  @Output() patchFormValues = new EventEmitter<IUserGroupDetails>();

  @Input() alreadySelectedGroups?: string[] | undefined;

  @Input() userStepper?: number | undefined;
  @Output() userStepperUpdate = new EventEmitter<number>();

  @Input() userGroup?: any | undefined;
  @Output() userGroupUpdate = new EventEmitter<any>();
  @ViewChild('groupListing') groupListing!: ElementRef;

  @Input() skipStepUserType: boolean = false;
  @Input() skipStepBuilding: boolean = false;
  @Input() isUserProfileFlow: boolean = false;
  @Input() userName?: string | undefined;
  commonAccessControl!: boolean;
  private readonly searchSubject$ = new Subject<string | undefined>();
  searchKeyPress: boolean = false;

  formGroup!: FormGroup;
  formGroupDevice!: FormGroup;

  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  readonly PageName = PageName;
  searchedWord: string = '';
  siteId!: string;
  sharedData!: any;
  dashboardList!: UserCards;
  @Input() buildingList: any;

  currentAlphabet: string | undefined;
  subscription: Subscription | undefined;

  constructor(
    private rootFormGroup: FormGroupDirective,
    public commonService: CommonService,
    private userManagementService: UserManagementService,
    public sharedDataService: SharedDataService,
    private ngRedux: NgRedux<IAppState>
  ) {}

  ngOnInit(): void {
    this.subscription = this.ngRedux
      .select('dashboardActivities')
      .subscribe((dashboardActivity: any) => {
        this.dashboardList = dashboardActivity;
      });
    this.formGroup = this.rootFormGroup?.control?.get(
      this.formGroupName
    ) as FormGroup;

    this.formGroupDevice = this.rootFormGroup?.control?.get(
      this.formGroupDeviceName
    ) as FormGroup;
    this.sharedDataService.currentData.subscribe((sharedData) => {
      this.sharedData = sharedData;
      this.commonAccessControl =
        this.sharedData.selectedSite.commonAccessControl;
    });
    // server-side search
    this.searchSubject$
      .pipe(debounceTime(200), distinctUntilChanged())
      .subscribe((searchQuery: any) => {
        this.searchedWord = searchQuery;
        this.callGetGroupsAPI();
      });
  }
  /**
   * @description: #callGetUserAPI function will call an API for getUsersBySite
   * @inut {none}
   * @output {void}
   */
  callGetGroupsAPI(): void {
    this.userManagementService
      .getUserGroupsBySite(
        this.sharedData?.selectedSite?.siteId,
        this.searchedWord,
        true
      )
      .subscribe({
        next: (res: any) => {
          this.userGroupList = res;
          this.userGroupList = addFlagIfMatched(
            this.dashboardList,
            this.userGroupList
          );
          this.userGroupList = this.userGroupList?.map((userGroup: any) => {
            if (this.alreadySelectedGroups?.includes(userGroup?.userGroupId)) {
              return { ...userGroup, active: true, alreadySelected: true };
            } else {
              return userGroup;
            }
          });
          this.formGroupDevice.patchValue({ group: [] });
          this.searchKeyPress = false;
        },
        error: (err: Error) => {
          this.searchKeyPress = false;
          if (window.__dev__) console.log('getUserGroupsBySite: ', err);
        },
      });
  }

  isEmpty(list: IUserGroupDetails[]) {
    return list && list?.length > 0 ? false : true;
  }

  addUserGroup() {
    this.buildingList?.forEach((building: any) => {
      building.buildingCount = 0;
    });
    this.patchFormValues.emit();
    this.stepper++;
    this.stepperChange.emit(this.stepper);
  }

  editUserGroup(userGroupItem: IUserGroupDetails) {
    this.patchFormValues.emit(userGroupItem);
    this.stepper++;
    this.stepperChange.emit(this.stepper);
  }
  searchThis(data: string) {
    this.searchKeyPress = true;
    this.searchSubject$.next(data);
  }

  checkIfNew(userGroupName: string) {
    if (this.currentAlphabet === userGroupName?.charAt(0).toLowerCase())
      return false;
    this.currentAlphabet = userGroupName?.charAt(0).toLowerCase();
    return true;
  }
  /**
   * @description Parent stepper back
   * @returns void
   */
  parentStepper(step: number): void {
    this.userGroupUpdate.emit(this.formGroupDevice?.value?.group);
    this.userStepperUpdate.emit((this.userStepper! += step));
  }

  /**
   * @description Parent stepper back
   * @returns void
   */
  sendSelectedGroup(selectedGroup: any): void {
    const step = 1;
    this.userGroupUpdate.emit(selectedGroup);
    this.userStepperUpdate.emit(
      (this.userStepper! += step + (this.skipStepUserType ? -1 : 0))
    );
  }

  /**
   * @description Submit to parent stepper forward
   * @returns void
   */
  submitToParent(step: number): void {
    this.userGroupUpdate.emit(this.formGroupDevice?.value?.group);
    // To show buildings if userGroup not user group is already selected.
    if (!this.formGroupDevice?.value?.group?.length && this.skipStepBuilding) {
      step--;
    }
    this.userStepperUpdate.emit(
      (this.userStepper! += step + (this.skipStepBuilding ? 1 : 0))
    );
  }
  ngAfterViewInit(): void {
    if (this.groupListing) {
      this.groupListing.nativeElement.focus();
    }
  }

  assignDeviceGroup() {
    const filtered = this.userGroupList.filter((x: any) => x.active);
    this.formGroup.patchValue({ group: filtered });
    this.stepper++;
    this.stepperChange.emit(this.stepper);
  }

  /**
   * @description current selected group index mark as active status
   * @param deviceGroup active number
   */
  activate(deviceGroup: IUserGroup): void {
    deviceGroup.active = !deviceGroup.active;
    const activeGroup = this.userGroupList
      ?.map((userGroup: any) => {
        userGroup.active === true;
        return userGroup;
      })
      ?.filter((userGroup: any) => userGroup.active === true);

    this.formGroupDevice.patchValue({ group: activeGroup });
  }

  /**
   * @description close modal popup
   * @returns void
   */
  closeDialog() {
    this.dialogRef?.close();
    return;
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
